import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AuthForm from './AuthForm';
import { register } from '../../services/authService';

const Register: React.FC = () => {
  const navigate = useNavigate();

  const handleRegister = async (data: any) => {
    await register(data, { establishSession: false });
    navigate('/login');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 6,
        background:
          'radial-gradient(circle at top, rgba(90, 75, 252, 0.12), transparent 40%), radial-gradient(circle at bottom, rgba(0, 184, 148, 0.16), transparent 45%), #f4f6fb',
      }}
    >
      <AuthForm onSubmit={handleRegister} isLogin={false} />
    </Box>
  );
};

export default Register;
